// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1xcS_","errorLogs":"EditorFooter_errorLogs__32czP"};